module.exports = __webpack_public_path__ + "static/media/archive.e66bd2ea.svg";